// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_FeedbackModel from '../../model/tdg-feedback-model';
import Tdg_FeedbackDTO from '../dto/tdg-feedback-dto';
import dtoSchema from '../schemas/tdg-feedback-schema';

export default abstract class Tdg_FeedbackModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_FeedbackDTO>) {
    super();
    if (data) {
      this.companyId = data.companyId;
      this.eventRating = data.eventRating;
      this.reparticipationRating = data.reparticipationRating;
      this.youthVisitorsCount = data.youthVisitorsCount;
      this.adultVisitorsCount = data.adultVisitorsCount ?? undefined;
      this.remark = data.remark ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  companyId?: number;
  /**
  * @type {int32}
  */
  eventRating?: 1 | 2 | 3; // EventRatingDTO
  /**
  * @type {int32}
  */
  reparticipationRating?: 1 | 2 | 3; // ReparticipationRatingDTO
  /**
  * @type {int32}
  */
  youthVisitorsCount?: number;
  /**
  * @type {int32}
  */
  adultVisitorsCount?: number;
  /**
  */
  remark?: string;

  static toModel(dto: DeepPartial<Tdg_FeedbackDTO>): Tdg_FeedbackModel;
  static toModel(dto: DeepPartial<Tdg_FeedbackDTO> | undefined | null): Tdg_FeedbackModel | undefined;
  static toModel(dto: DeepPartial<Tdg_FeedbackDTO> | undefined | null): Tdg_FeedbackModel | undefined {
    return dto ? new Tdg_FeedbackModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_FeedbackModel> | Tdg_FeedbackModel): Tdg_FeedbackDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      companyId: unwrapped.companyId,
      eventRating: unwrapped.eventRating,
      reparticipationRating: unwrapped.reparticipationRating,
      youthVisitorsCount: unwrapped.youthVisitorsCount,
      adultVisitorsCount: unwrapped.adultVisitorsCount,
      remark: unwrapped.remark,
    } as Tdg_FeedbackDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_FeedbackModel, can not map to Tdg_FeedbackDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
